function preventScrollForSwipableElement(slider) {
    let firstSwipeEvent = null

    slider.addEventListener("touchstart", function (e) {
        firstSwipeEvent = e
    })

    slider.addEventListener("touchmove", function (e) {
        if(!firstSwipeEvent) {
            console.log("No original swipe event exists yet.")
            return
        }

        let latestSwipeEvent = e

        let distanceMoved = calculateDistanceMoved(firstSwipeEvent, latestSwipeEvent)

        const distanceMovedThreshold = 10
        if(distanceMovedThreshold < 10) {
            console.log("Mouse has not moved far enough to know user intent.", {distanceMoved})
            e.preventDefault()
            return
        }

        let swipeAngle = calculateSwipeAngle(firstSwipeEvent, latestSwipeEvent)
        let direction = determineMovementDirection(swipeAngle)

        if(direction.direction == 'left' || direction.direction == 'right') {
            console.log("Preventing default because swipe direction was ", direction)
            e.preventDefault()
            return
        }

        const swipeDegrees = Math.abs(direction.offset)  
      
        const swipeThresholdDegreesUp = 30 // Up swipe is less selective, because scrolling down is common
        const swipeThresholdDegreesDown = 15 // Down swipe is more selective, because swiping down refreshes page.
        
        // Handle up/down swipe
        if( direction.direction == "up" && swipeDegrees > swipeThresholdDegreesUp ) {
            console.log("Preventing default because swipe was ", swipeDegrees, 'degrees', 'and threshold is', swipeThresholdDegreesUp)
            e.preventDefault()
            return
        }

        if( direction.direction == "down" && swipeDegrees > swipeThresholdDegreesDown ) {
            console.log("Preventing default because swipe was ", swipeDegrees, 'degrees', 'and threshold is', swipeThresholdDegreesDown)
            e.preventDefault()
            return
        }


        console.log("Allowing swipe to initiate a scroll action.")
    })

    slider.addEventListener("touched", function (e) {
        firstSwipeEvent = null
    })

}

function calculateDistanceMoved(firstSwipeEvent, latestSwipeEvent) {
    const x1 = firstSwipeEvent.touches[0].pageX
    const y1 = firstSwipeEvent.touches[0].pageY
    const x2 = latestSwipeEvent.touches[0].pageX 
    const y2 = latestSwipeEvent.touches[0].pageY

    // Pythagorean theorem.
    const sideA = x1 - x2
    const sideB = y1 - y2
    const distance = Math.sqrt(Math.pow(sideA, 2) + Math.pow(sideB, 2));

    return distance
}

// Returns {direction: 'up', offset: 15}
// when movement is upwards, but 15 degrees clockwise
// Returns {direction: 'up', offset: -15} for counter-clockwise.
function determineMovementDirection(angle) {
    const absAngle = (angle + 180) // convert degrees from {-180 to +180} scale into {0 to 360}

    // Converts our "angle" into a number 0 through 4.
    // 0 and 4 are actually both left. This happens because it's where 360 deg reverts back to 0 deg.
    const directionId = Math.round( absAngle / 90 )
    const direction = ['left', 'up', 'right', 'down', 'left'][directionId]
    
    const directionBaseAngle = directionId * 90
    const offset = absAngle - directionBaseAngle

    return {direction, offset}
}

function calculateSwipeAngle(firstSwipeEvent, latestSwipeEvent) {
    const x1 = firstSwipeEvent.touches[0].pageX
    const y1 = firstSwipeEvent.touches[0].pageY
    const x2 = latestSwipeEvent.touches[0].pageX 
    const y2 = latestSwipeEvent.touches[0].pageY

    const angle = Math.atan2( y2 - y1, x2 - x1 ) * ( 180 / Math.PI )

    return angle
}

Array.from(document.querySelectorAll('.flickity-viewport')).forEach(element => preventScrollForSwipableElement(element))
